/**
 * Decodifica dei dati legacy
 */

const $decode = {
  methods: {
    $decodeTipoCorso (corso, type) {
      if (!['long', 'short'].includes(type)) {
        console.warn('decodeTipoCorso mixin invalid type')
        return ''
      } else {
        try {
          switch (corso.siglatipologia) {
            case 31:
              return type === 'long' ? 'Laurea magistrale' : 'LM'
            case 30:
              return type === 'long' ? 'Corso di laurea' : 'L'
            case 25:
              return type === 'long' ? 'Lauree magistrali a ciclo unico (5 o 6 anni)' : 'CU'
            default:
              return 'ND'
          }
        } catch (err) {
          console.log('tipoCorso mixin error', err)
          return ''
        }
      }
    },
    $decodeAmbitoCorso (corso, type) {
      if (!['long', 'short'].includes(type)) {
        console.warn('decodeAmbitoCorso mixin invalid type')
        return ''
      } else {
        try {
          switch (corso.cod_area) {
            case 10:
              return type === 'long' ? 'Architettura e design' : 'ARC'
            case 28:
              return type === 'long' ? 'Economia' : 'ECO'
            case 8:
              return type === 'long' ? 'Farmacia' : 'FARMA'
            case 1:
              return type === 'long' ? 'Giurisprudenza' : 'GIU'
            case 9:
              return type === 'long' ? 'Ingegneria' : 'ING'
            case 4:
              return type === 'long' ? 'Lettere e filosofia' : 'LET'
            case 27:
              return type === 'long' ? 'Lingue e letterature straniere' : 'LIN'
            case 6:
              return type === 'long' ? 'Medicina e chirugia' : 'MED'
            case 5:
              return type === 'long' ? 'Scienze della formazione' : 'FOR'
            case 7:
              return type === 'long' ? 'Scienze matematiche, fisiche e naturali' : 'MFN'
            case 2:
              return type === 'long' ? 'Scienze politiche' : 'POL'
            default:
              return 'ND'
          }
        } catch (err) {
          console.log('tipoCorso mixin error', err)
          return ''
        }
      }
    }
  }
}

export {
  $decode
}
